import { Flex, FloraButton } from '@grupoboticario/flora-react';
import { SquareArrowRightUpIcon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components';

import Styles from './Help.styles';
import ProfileComponentsStyles from '../Profile.components.styles';

export const Help = () => {
  return (
    <Flex gap='$4' direction='column'>
      <ResponsiveFloraTypography fontSize='title' as='h2' fontWeight='bold'>
        Possui alguma dúvida?
      </ResponsiveFloraTypography>
      <Styles.Wrapper direction='column' gap='$6'>
        <Flex gap='$4' direction='column'>
          <ProfileComponentsStyles.SubText>
            Tenha acesso às principais dúvidas ou inicie uma conversa em tempo real com nosso Chat
            com Assistente.
          </ProfileComponentsStyles.SubText>

          <Flex gap='$4'>
            <Styles.ButtonContactWrapper>
              <FloraButton
                as={Link}
                color='$conversionButtonDefault'
                autotagging-flora='on'
                data-flora-text='dúvidas-frequentes'
                data-flora='button'
                rel='noopenner noreferrer'
                target='_blank'
                to='https://atendimento.force.com/eudorarepresentante/s/'
                hierarchy='secondary'
              >
                <Flex gap='$2'>
                  <SquareArrowRightUpIcon size={16} />
                  Dúvidas frequentes
                </Flex>
              </FloraButton>
            </Styles.ButtonContactWrapper>
          </Flex>
        </Flex>
      </Styles.Wrapper>
    </Flex>
  );
};
